import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { OrderHeaderProps } from '../../components/order-summary/OrderSummary';
import { MarginType } from './margin';
import MarginComponent from '../../components/customComponents/MarginComponent';
import PaddingComponent from '../../components/customComponents/PaddingComponent';
import { PaddingType } from './padding';
import ColorPicker from './ColorPicker';
import { Select } from '../../components/form-fields/Select';
import CustomTooltip from '../../../components/common/tooltip';
import { FieldLabel } from '@measured/puck';
import { fontSizeOptions, fontWeightOptions } from './font';

interface OrderSummaryHeaderProps {
  value: OrderHeaderProps;
  onChange: (_value: OrderHeaderProps) => void;
  title: string;
  showComponent?: boolean;
  showHover?: boolean;
}

const OrderSummaryHeader: React.FC<OrderSummaryHeaderProps> = ({
  value,
  onChange,
  title,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3  border border-gray-300 rounded p-2 w-full">
          <MarginComponent
            value={value.margin}
            onChange={(values: MarginType) => {
              onChange({ ...value, margin: values });
            }}
          />
          <PaddingComponent
            value={value.padding}
            onChange={(values: PaddingType) => {
              onChange({ ...value, padding: values });
            }}
          />
          <div>
            <div
              className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
              onClick={() => setIsOpen2(!isOpen2)}>
              <h3>Customize {title}</h3>
              {!isOpen2 ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
            </div>
            {isOpen2 && (
              <div className="flex flex-col gap-4 mt-3 m-auto border border-gray-300 rounded py-2 px-4">
                <ColorPicker
                  value={value.HeaderText?.textColor}
                  onChange={color =>
                    onChange({
                      ...value,
                      HeaderText: {
                        ...value.HeaderText,
                        textColor: color,
                      },
                    })
                  }
                  label={'Text Color'}
                  tooltip={'textColor'}
                />
                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="fontSize">
                        <span>Font Size</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <Select
                    className="pagebuilder-theme"
                    value={value?.HeaderText?.fontSize}
                    onChange={e =>
                      onChange({
                        ...value,
                        HeaderText: {
                          ...value.HeaderText,
                          fontSize: e.target.value,
                        },
                      })
                    }
                    options={fontSizeOptions}
                    label="Size"
                  />
                </FieldLabel>

                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="fontWeight">
                        <span>Font Weight</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <Select
                    value={value?.HeaderText?.fontWeight}
                    onChange={e =>
                      onChange({
                        ...value,
                        HeaderText: {
                          ...value.HeaderText,
                          fontWeight: e.target.value,
                        },
                      })
                    }
                    options={fontWeightOptions}
                  />
                </FieldLabel>

                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="opentext">
                        <span>Open Text</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <input
                    type="text"
                    id="openText"
                    value={value.HeaderText?.openText}
                    onChange={e => {
                      onChange({
                        ...value,
                        HeaderText: {
                          ...value.HeaderText,
                          openText: e.target.value,
                        },
                      });
                    }}
                  />
                </FieldLabel>

                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="opentext">
                        <span>Close Text</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <input
                    type="text"
                    id="openText"
                    value={value.HeaderText?.closeText}
                    onChange={e => {
                      onChange({
                        ...value,
                        HeaderText: {
                          ...value.HeaderText,
                          closeText: e.target.value,
                        },
                      });
                    }}
                  />
                </FieldLabel>
              </div>
            )}
          </div>
          <ColorPicker
            value={value.backgroundColor}
            onChange={color => {
              onChange({
                ...value,
                backgroundColor: color,
              });
            }}
            label={'Background Color'}
            tooltip={'backgroundColor'}
          />
          <FieldLabel
            label={
              (
                <CustomTooltip title="device">
                  <span>Device</span>
                </CustomTooltip>
              ) as React.ReactNode as string
            }>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                className="!appearance-auto"
                checked={value?.showOnDesktop}
                onChange={e =>
                  onChange({
                    ...value,
                    showOnDesktop: e.target.checked,
                  })
                }
              />
              <label>Show on desktop</label>
            </div>
            <div className="flex items-center space-x-2 mt-2">
              <input
                type="checkbox"
                className="!appearance-auto"
                checked={value?.showOnTablet}
                onChange={e =>
                  onChange({
                    ...value,
                    showOnTablet: e.target.checked,
                  })
                }
              />
              <label>Show on tablet</label>
            </div>
            <div className="flex items-center space-x-2 mt-2">
              <input
                type="checkbox"
                className="!appearance-auto"
                checked={value?.showOnMobile}
                onChange={e =>
                  onChange({
                    ...value,
                    showOnMobile: e.target.checked,
                  })
                }
              />
              <label>Show on mobile</label>
            </div>
          </FieldLabel>
        </div>
      )}
    </div>
  );
};

export default OrderSummaryHeader;
